// src/pages/workout/PainExerciseGuide/index.js
import { useNavigate } from "react-router-dom";
import { useLoadingGate } from "../../../../hooks/useLoadingGate";
import AuthCard from "../../../../components/auth/AuthCard";
import BottomNav from "../../../../components/common/BottomNav";
import painExerciseImg from "../../../../assets/images/painExercise.png";

const HOTSPOTS = [
    { key: "shoulder", label: "어깨", x: 34, y: 20 },
    { key: "neck", label: "목", x: 55, y: 15 },
    { key: "arm", label: "팔", x: 69, y: 36 },
    { key: "abdomen_lumbar", label: "복부 / 허리", x: 50, y: 42 },
    { key: "thigh", label: "상퇴", x: 42, y: 57 },
    { key: "lower_leg", label: "하퇴", x: 60, y: 80 },
];

export default function PainExerciseGuide() {
    const ready = useLoadingGate();
    const navigate = useNavigate();

    const handleHotspot = (spot) => {
        const qs = new URLSearchParams({
            cat: "pain",
            item: spot.key,
            title: `${spot.label} 근육`,
        }).toString();

        navigate(`/workout/conditionguide/pain/area?${qs}`);
    };

    return (
        <main className="h-[var(--app-height)] flex flex-col font-suit overflow-y-auto scrollbar-hide px-7 md:px-8 bg-white">
            {!ready ? (
                <div className="flex-1" />
            ) : (
                <AuthCard
                    className="flex-1 w-full mx-auto"
                    title={"통증별 운동 가이드"}
                    onClose={() => navigate(-1)}
                >
                    <div className="flex flex-col flex-1 pt-3 md:pt-4 pb-24 md:pb-28">
                        <p className="text-sm md:text-base text-[#1F4FD3] font-semibold">
                            통증 부위를 눌러 적절한 운동을 살펴 보세요.
                        </p>

                        <div className="mt-3 md:mt-4 rounded-2xl border border-gray-200 bg-white">
                            <div className="relative mx-auto p-3 w-full max-w-md aspect-[3/5]">
                                <div className="absolute inset-x-0 top-10 bottom-10 md:top-6 md:bottom-6">
                                    <div className="relative w-full h-full">
                                        {/* 마스크된 회색 실루엣 */}
                                        <div
                                            className="absolute inset-0 bg-[#CBCBCB]"
                                            style={{
                                                WebkitMaskImage: `url(${painExerciseImg})`,
                                                WebkitMaskRepeat: "no-repeat",
                                                WebkitMaskPosition: "center",
                                                WebkitMaskSize: "contain",
                                                maskImage: `url(${painExerciseImg})`,
                                                maskRepeat: "no-repeat",
                                                maskPosition: "center",
                                                maskSize: "contain",
                                            }}
                                        />
                                        {/* 핫스팟 (좌표는 그대로, 래퍼 안에서 퍼센트 기준으로 맞춰짐) */}
                                        {HOTSPOTS.map((s) => (
                                            <button
                                                key={s.key}
                                                type="button"
                                                onClick={() => handleHotspot(s)}
                                                className="absolute -translate-x-1/2 -translate-y-1/2 rounded-full flex items-center justify-center"
                                                style={{ left: `${s.x}%`, top: `${s.y}%` }}
                                                aria-label={`${s.label} 보기`}
                                            >
                                                <span className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-red-300/60 ring-1 ring-red-300/70 backdrop-blur-[1px]" />
                                                <span className="absolute mt-1 text-[13px] md:text-sm font-bold text-black whitespace-nowrap">
                                                    {s.label}
                                                </span>
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </AuthCard>
            )}

            <BottomNav className="h-16 md:h-[72px]" />
        </main>
    );
}
